/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ParamSize } from '../components/add-family-information/add-family-information-types';
import { ProjectDataReturnCodes } from '../models/project-data-return-codes';
import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';
import { GlobalConstants } from '../constants/global-constants';

export class AssignProjectDataReceiveController {
  constructor(private localStorageService: LocalStorageService) {}

  public ImportExportExcelResult(response: ProjectDataReturnCodes, paramSizes: ParamSize[]): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.IMPORT_EXPORT_EXCEL_RESPONSE, {
      response,
      paramSizes,
    });
  }
}
